export var ManagerHistorySearchType;
(function (ManagerHistorySearchType) {
    ManagerHistorySearchType["DISPATCH_AREA"] = "DISPATCH_AREA";
    ManagerHistorySearchType["RESERVED_VEHICLE"] = "RESERVED_VEHICLE";
    ManagerHistorySearchType["DRIVER_LICENSE_IMAGE"] = "DRIVER_LICENSE_IMAGE";
})(ManagerHistorySearchType || (ManagerHistorySearchType = {}));
